export const siteConfig = {
  name: '吃瓜网在线',
  tagline: '网红塌房 · 实时追踪 · 一站吃瓜',
  description: '聚合51吃瓜网在线观看、黑料吃瓜网在线观看等热门入口，实时追踪网红塌房事件与黑料爆料视频，一站满足用户在线吃瓜需求。',
  url: 'http://shangremen.cn/',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '黑料爆料', href: '/category/黑料爆料' },
  { label: '网红塌房', href: '/category/网红塌房' },
  { label: '吃瓜视频', href: '/category/吃瓜视频' },
  { label: '关于我们', href: '/about' },
];

export const heroArticles = [
  {
    id: 'hot-1',
    title: '某千万粉丝网红深夜直播翻车，',
    titleLine2: '黑历史被扒出引发全网热议',
    description: '知名网红在直播中意外说漏嘴，被网友扒出大量过往黑料，包括虚假人设、慈善造假等多项指控，短短24小时内掉粉超200万。',
    category: '黑料爆料',
    slug: 'qianwan-fensi-wanghong-zhibo-fanche',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20news%20editorial%20scene%20with%20warm%20ambient%20lighting%20and%20muted%20color%20palette%2C%20featuring%20an%20abstract%20composition%20of%20social%20media%20symbols%20and%20dramatic%20shadows%20on%20a%20cream%20background%2C%20editorial%20photography%20style%20with%20soft%20contrast%2C%20cinematic%20mood%2C%20elegant%20minimalist%20aesthetic&width=800&height=600&seq=hero-article-01&orientation=landscape',
    date: '2026-07-06',
    views: 1280000,
  },
];

export const hotGossipArticles = [
  {
    id: 'gossip-1',
    title: '顶流女星疑似恋情曝光',
    category: '黑料爆料',
    summary: '深夜被拍与神秘男子同回公寓',
    views: 986000,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20tones%20and%20soft%20lighting%2C%20featuring%20an%20abstract%20paparazzi%20scene%20with%20blurred%20city%20night%20lights%20in%20the%20background%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20magazine%20editorial%20aesthetic%2C%20elegant%20composition&width=600&height=450&seq=gossip-card-01&orientation=landscape',
    slug: 'dingliu-nuxing-lianqing-baoguang',
    date: '2026-07-07',
  },
  {
    id: 'gossip-2',
    title: '知名带货主播被曝虚假宣传',
    category: '黑料爆料',
    summary: '产品质量遭消费者集体投诉',
    views: 756000,
    image: 'https://readdy.ai/api/search-image?query=An%20editorial%20style%20photograph%20with%20warm%20lighting%20and%20soft%20shadows%2C%20featuring%20an%20abstract%20livestream%20shopping%20scene%20with%20product%20boxes%20scattered%20in%20a%20minimalist%20studio%20setting%2C%20cream%20and%20warm%20gray%20color%20palette%2C%20sophisticated%20magazine%20aesthetic&width=600&height=450&seq=gossip-card-02&orientation=landscape',
    slug: 'zhiming-daihuo-zhubo-xujia-xuanchuan',
    date: '2026-07-06',
  },
  {
    id: 'gossip-3',
    title: '选秀艺人私生活混乱再添实锤',
    category: '黑料爆料',
    summary: '多名前女友联合发文指责',
    views: 623000,
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20editorial%20photograph%20with%20warm%20ambient%20light%20and%20deep%20shadows%2C%20featuring%20an%20abstract%20backstage%20entertainment%20scene%20with%20mirror%20reflections%20and%20dramatic%20lighting%2C%20muted%20warm%20cream%20and%20beige%20tones%2C%20fashion%20editorial%20aesthetic&width=600&height=450&seq=gossip-card-03&orientation=landscape',
    slug: 'xuanxiu-yiren-sishenghuo-shichui',
    date: '2026-07-05',
  },
  {
    id: 'gossip-4',
    title: '音乐节现场爆发粉丝冲突事件',
    category: '网红塌房',
    summary: '多名网红被指煽动粉丝对立',
    views: 512000,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20golden%20lighting%2C%20featuring%20an%20abstract%20music%20festival%20scene%20with%20stage%20lights%20and%20crowd%20silhouettes%2C%20soft%20cream%20and%20amber%20color%20palette%2C%20cinematic%20magazine%20aesthetic%20with%20motion%20blur&width=600&height=450&seq=gossip-card-04&orientation=landscape',
    slug: 'yinyuejie-fensi-chongtu-shijian',
    date: '2026-07-04',
  },
  {
    id: 'gossip-5',
    title: '短剧顶流被爆天价片酬争议',
    category: '网红塌房',
    summary: '单集报价超一线演员引发讨论',
    views: 445000,
    image: 'https://readdy.ai/api/search-image?query=An%20editorial%20photograph%20with%20warm%20lighting%20and%20soft%20contrast%2C%20featuring%20an%20abstract%20film%20set%20scene%20with%20camera%20equipment%20and%20dramatic%20shadows%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20style&width=600&height=450&seq=gossip-card-05&orientation=landscape',
    slug: 'duanju-dingliu-tianjia-pianchou',
    date: '2026-07-03',
  },
];

export const celebrityTracking = [
  {
    id: 'track-1',
    name: '网红小王塌房全纪录',
    category: '网红塌房',
    description: '从千万粉到全面封杀，完整时间线复盘',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20muted%20tones%2C%20featuring%20an%20abstract%20portrait%20in%20shadow%20with%20falling%20social%20media%20icons%2C%20minimalist%20cream%20background%2C%20magazine%20editorial%20aesthetic%20with%20soft%20dramatic%20lighting&width=600&height=420&seq=track-card-01&orientation=landscape',
    slug: 'wanghong-xiaowang-tafang-quanjilu',
    date: '2026-07-07',
  },
  {
    id: 'track-2',
    name: '女主播人设崩塌事件簿',
    category: '网红塌房',
    description: '从清纯女神到人人喊打，真相令人唏嘘',
    image: 'https://readdy.ai/api/search-image?query=An%20editorial%20photograph%20with%20warm%20lighting%20and%20deep%20shadows%2C%20featuring%20an%20abstract%20livestreaming%20studio%20scene%20with%20ring%20light%20and%20microphone%2C%20muted%20cream%20and%20gray%20color%20palette%2C%20sophisticated%20magazine%20aesthetic&width=600&height=420&seq=track-card-02&orientation=landscape',
    slug: 'nvzhubo-renshe-bengta-shijianbu',
    date: '2026-07-06',
  },
  {
    id: 'track-3',
    name: '带货一哥暴雷始末',
    category: '黑料爆料',
    description: '曾被奉为行业标杆，如今深陷多重丑闻',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20editorial%20photograph%20with%20warm%20golden%20lighting%2C%20featuring%20an%20abstract%20e-commerce%20warehouse%20scene%20with%20packages%20and%20shipping%20labels%2C%20muted%20cream%20and%20amber%20color%20palette%2C%20cinematic%20magazine%20editorial%20style&width=600&height=420&seq=track-card-03&orientation=landscape',
    slug: 'daihuo-yige-baolei-shimo',
    date: '2026-07-05',
  },
];

export const videoSection = {
  title: '吃瓜视频',
  subtitle: '热门爆料视频，一网打尽',
  videos: [
    {
      id: 'video-1',
      title: '网红直播翻车名场面合集',
      views: 2560000,
      image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20photograph%20with%20warm%20lighting%2C%20featuring%20an%20abstract%20video%20player%20interface%20with%20play%20button%20and%20timeline%20on%20a%20minimalist%20cream%20background%2C%20soft%20shadows%2C%20magazine%20aesthetic&width=600&height=380&seq=video-card-01&orientation=landscape',
      slug: 'wanghong-zhibo-fanche-mingchangmian',
      date: '2026-07-07',
    },
    {
      id: 'video-2',
      title: '明星采访尴尬瞬间大盘点',
      views: 1890000,
      image: 'https://readdy.ai/api/search-image?query=An%20editorial%20style%20photograph%20with%20warm%20tones%2C%20featuring%20an%20abstract%20interview%20studio%20scene%20with%20microphones%20and%20spotlight%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20elegant%20magazine%20editorial%20aesthetic&width=600&height=380&seq=video-card-02&orientation=landscape',
      slug: 'mingxing-caifang-ganga-shunjian',
      date: '2026-07-06',
    },
    {
      id: 'video-3',
      title: '娱乐圈未解之谜深度分析',
      views: 1340000,
      image: 'https://readdy.ai/api/search-image?query=A%20moody%20editorial%20photograph%20with%20warm%20golden%20lighting%2C%20featuring%20an%20abstract%20mystery%20scene%20with%20magnifying%20glass%20and%20newspaper%20clippings%2C%20muted%20cream%20and%20amber%20tones%2C%20cinematic%20magazine%20aesthetic&width=600&height=380&seq=video-card-03&orientation=landscape',
      slug: 'yulequan-weijiezhimi-shendu-fenxi',
      date: '2026-07-05',
    },
    {
      id: 'video-4',
      title: '2026上半年塌房网红排行榜',
      views: 978000,
      image: 'https://readdy.ai/api/search-image?query=An%20editorial%20photograph%20with%20warm%20lighting%20and%20soft%20contrast%2C%20featuring%20an%20abstract%20ranking%20chart%20with%20falling%20icons%20on%20a%20minimalist%20cream%20background%2C%20sophisticated%20magazine%20editorial%20style&width=600&height=380&seq=video-card-04&orientation=landscape',
      slug: '2026-shangbannian-tafang-wanghong-paihang',
      date: '2026-07-04',
    },
  ],
};

export const footerLinks = {
  platform: {
    title: '平台导航',
    links: [
      { label: '黑料爆料', href: '/category/黑料爆料' },
      { label: '网红塌房', href: '/category/网红塌房' },
      { label: '吃瓜视频', href: '/category/吃瓜视频' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '免责声明', href: '/about#disclaimer' },
    ],
  },
  legal: {
    title: '法律声明',
    links: [
      { label: '隐私政策', href: '/about#privacy' },
      { label: '用户协议', href: '/about#terms' },
      { label: '投诉建议', href: '/about#contact' },
    ],
  },
};

export const categories = [
  { name: '黑料爆料', slug: '黑料爆料', icon: 'ri-alert-line', count: 1286 },
  { name: '网红塌房', slug: '网红塌房', icon: 'ri-building-2-line', count: 953 },
  { name: '吃瓜视频', slug: '吃瓜视频', icon: 'ri-vidicon-line', count: 2104 },
  { name: '娱乐圈', slug: '娱乐圈', icon: 'ri-movie-line', count: 872 },
  { name: '直播圈', slug: '直播圈', icon: 'ri-live-line', count: 645 },
  { name: '电竞圈', slug: '电竞圈', icon: 'ri-gamepad-line', count: 431 },
];